<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
  }

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="paymentConfirmDate" inputId="paymentConfirmDate" appendTo="body">
            </p-calendar>
            <label for="paymentConfirmDate">PaymentConfirm Date</label>
            @for (validation of validationMessages.paymentConfirmDate; track validation) {
              <span>
                @if (form1.get('paymentConfirmDate').hasError(validation.type) && (form1.get('paymentConfirmDate').dirty || form1.get('paymentConfirmDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <h6 for="isPaymentConfirm">PaymentConfirm Options</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['isPaymentConfirm']" inputId="isPaymentConfirm" [binary]="true"></p-checkbox>
            <span class="paymentConfirm-nm">Is PaymentConfirm?</span>
          </div>
          @for (validation of validationMessages.isPaymentConfirm; track validation) {
            <span>
              @if (form1.get('isPaymentConfirm').hasError(validation.type) && (form1.get('isPaymentConfirm').dirty || form1.get('isPaymentConfirm').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (paymentConfirmId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                [disabled]="formLoading" (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="formLoading ? null : true">Cancel</button>
              @if (!paymentConfirmId) {
                <button pButton class="btn-addt p-button" [disabled]="formLoading" (click)="formAdd()">
                  @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Add
                </button>
              }

              @if (paymentConfirmId) {
                <button pButton class="btn-upt p-button" [disabled]="formLoading" (click)="formUpdate()">
                  @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Update
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>